module.exports = __webpack_public_path__ + "img/Falkberget__To_mektige_historiske_romanserier.a5a6e870.jpg";